import $ from "jquery";
import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";

import {handleHubspotForm} from "util/hubspot";
import Page from "webPage/Page";
import {handleNavigation} from "util/Navigation";
import Track from "util/Track";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute("data-useragent", navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $("html").addClass("ie11");
    }

    svg4everybody();

    Page.init();

    $(".js-hubspot-form").each(function () {
        handleHubspotForm($(this));
    });

    handleNavigation();

    let $articles_track = $(".js-articles-track-wrap");
    if ($articles_track.length > 0) {
        new Track($articles_track, {
            classes: {
                block: "slider",
            },
        });
    }

    let $caseStudy_track = $(".js-case-study-track-wrap");
    if ($caseStudy_track.length > 0) {
        new Track($caseStudy_track, {
            classes: {
                block: "slider",
            },
        });
    }

    $("body")
        .on("click", ".js-show-share-icons", function () {
            $(this).toggleClass("share--active");
            return false;
        })
        .on("click", ".js-footer-toggle", function () {
            $(this).parent().toggleClass("footer-navigations__navigation--active");
            return false;
        })
        .on("click", ".js-scroll-to", function () {
            let id = $(this).attr("href");
            let scrollTop = $(id).offset().top;
            $("html, body").animate({scrollTop: scrollTop - 70}, 300);
            return false;
        });
});

export function svg_include(icon, suffix = "") {
    return (
        '<svg><use xlink:href="/wp-content/themes/avery-berkel-core/includes/svg-icons.svg?#' +
        icon +
        '"></use></svg>'
    );
}

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
